import React, { useRef, useState } from 'react';

import Rechercher from '../../components/Rechercher';
import { getMainNav } from '../../shared/siteNav';
import logoImg from '@public/images/logo.png';
import qrcode1Img from '@public/images/qrcode1.png';
import qrcode2Img from '@public/images/qrcode2.png';
import indexBg from '@public/images/home/index-bg.jpg';
import homeVideo26 from '@public/images/home/home_video_26.jpg';
import homeVideo25 from '@public/images/home/home_video_25.jpg';
import homeVideo24 from '@public/images/home/home_video_24.jpg';
import homeVideo23 from '@public/images/home/home_video_23.jpg';
import homeVideo22 from '@public/images/home/home_video_22.jpg';
import video4Poster from '@public/images/home/video4.png';
import cardAbout from '@public/images/home/index-1.jpg';
import cardCollege from '@public/images/home/445.jpg';
import cardTalent from '@public/images/home/index-4.jpg';
import cardSociety from '@public/images/home/index-2.jpg';

const NAV_ITEMS = getMainNav('home');

const HOME_VIDEOS = [
  {
    src: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/07fc30bb5001834808830396301/v.f100030.mp4',
    poster: homeVideo26,
  },
  {
    src: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/f4fad7ad5001834808826859382/v.f100030.mp4',
    poster: homeVideo25,
  },
  {
    src: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/5d340f855001834808824933464/v.f100030.mp4',
    poster: homeVideo24,
  },
  {
    src: 'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/97a7931a5001834808825150461/A8ZYjYaVLa4A.mp4',
    poster: homeVideo23,
  },
  {
    src: 'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/97a7825c5001834808825150085/aR43zEM9ZJQA.mp4',
    poster: homeVideo22,
  },
  {
    src: 'https://1500000890.vod2.myqcloud.com/438181a1vodtranscq1500000890/9e8732465001834808825438167/v.f100030.mp4',
    poster: video4Poster,
  },
];

const ENTRY_CARDS = [
  { title: '公司概述', href: 'about.html', image: cardAbout },
  { title: '校园项目', href: 'recruitCollege.html', image: cardCollege, className: 'list list1' },
  { title: '雇主品牌', href: 'talentCommitment.html', image: cardTalent, className: 'list list1' },
  { title: '社会招聘', href: 'recruitSociety.html', image: cardSociety, className: 'list list2' },
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const videoRef = useRef(null);

  const activeVideo = HOME_VIDEOS[activeVideoIndex];

  const switchVideo = (index) => {
    setActiveVideoIndex(index);
    const video = videoRef.current;
    if (video) {
      video.load();
      video.play().catch(() => {});
    }
  };

  return (
    <div className={`bi-home-page${menuOpen ? ' menu-open' : ''}`}>
      <button
        type="button"
        className="rightMenuBtn"
        aria-label="打开菜单"
        onClick={() => setMenuOpen((open) => !open)}
      >
        <span className={menuOpen ? 'closeMenu' : 'openMenu'} />
      </button>

      <header className="site-header">
        <div className="w1200 clearfix">
          <div className="logo">
            <a href="index.html">
              <img src={logoImg} alt="勃林格殷格翰" />
            </a>
          </div>
          <nav className="mainnav">
            <ul>
              {NAV_ITEMS.map((item) => (
                <li key={item.label} className={item.active ? 'on' : ''}>
                  <a href={item.href}>{item.label}</a>
                </li>
              ))}
            </ul>
          </nav>
          <div className="le-code">
            <ul>
              <li>
                <img src={qrcode1Img} alt="二维码" />
              </li>
              <li>
                <img src={qrcode2Img} alt="二维码" />
              </li>
            </ul>
          </div>
        </div>
      </header>

      <main id="mian" className="page-main">
        <div className="index-mian" style={{ backgroundImage: `url(${indexBg})` }}>
          <div className="w1200 clearfix por">
            <div className="video video1">
              <dl>
                <dt>
                  <video
                    ref={videoRef}
                    key={activeVideo.src}
                    controls
                    poster={activeVideo.poster}
                    src={activeVideo.src}
                  />
                  <div className="video-text">点击上方视频，解锁&quot;人才承诺&quot;</div>
                </dt>
                <dd>
                  <ul>
                    {HOME_VIDEOS.slice(1).map((video, index) => (
                      <li
                        key={video.src}
                        role="button"
                        tabIndex={0}
                        onClick={() => switchVideo(index + 1)}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            switchVideo(index + 1);
                          }
                        }}
                      >
                        <img src={video.poster} alt="" />
                        <span />
                      </li>
                    ))}
                  </ul>
                </dd>
              </dl>
            </div>

            <aside className="colonne">
              <Rechercher />
            </aside>

            <div className="index-box">
              <div className="left">
                <div className="index-time">
                  <a href={ENTRY_CARDS[0].href} aria-label={ENTRY_CARDS[0].title} />
                  <div className="img">
                    <img src={ENTRY_CARDS[0].image} alt={ENTRY_CARDS[0].title} />
                  </div>
                  <div className="pack">
                    <div className="title">{ENTRY_CARDS[0].title}</div>
                  </div>
                </div>
              </div>
              <div className="right">
                {ENTRY_CARDS.slice(1).map((card) => (
                  <div className={`index-time ${card.className}`} key={card.href}>
                    <a href={card.href} aria-label={card.title} />
                    <div className="img">
                      <img src={card.image} alt={card.title} />
                    </div>
                    <div className="pack">
                      <div className="title">{card.title}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="site-footer">
        <div className="w1200">
          <div className="icp">
            联系我们:{' '}
            <a href="mailto:HRTalent.CN@boehringer-ingelheim.com">
              HRTalent.CN@boehringer-ingelheim.com
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
